import PropTypes from 'prop-types';
import { icons } from '@shared/static/icons';

Note.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'error', 'success']).isRequired,
  title: PropTypes.string,
  icon: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.node,
  marginBottom: PropTypes.bool,
  marginTop: PropTypes.bool,
  singleLine: PropTypes.bool,
  noIcon: PropTypes.bool,
  html: PropTypes.bool,
};

export default function Note({
  type,
  title,
  icon,
  content,
  children,
  marginBottom,
  marginTop,
  singleLine,
  noIcon = false,
  html = false,
}) {
  const className = [
    'note',
    `note--${type}`,
    singleLine && 'note--singleLine',
    marginBottom && 'mb',
    marginTop && 'mt',
  ]
    .filter(Boolean)
    .join(' ');

  const contentProps = html
    ? { dangerouslySetInnerHTML: { __html: content } }
    : { children: content };

  return (
    <div className={className}>
      {singleLine ? (
        <div className="note__title">
          {!noIcon && icons[icon ?? type]}
          <p {...contentProps} />
        </div>
      ) : (
        <>
          <div className="note__title fw-500">
            {icons[type]}
            {title}
          </div>
          {content && <p className="note__content" {...contentProps} />}
        </>
      )}
      {children && <div className="note__child">{children}</div>}
    </div>
  );
}
